<template>
  <transition name="modal">
    <div v-if="isVisible" class="modal-mask" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-content">
          <!-- 第一行：语录文本 -->
          <div class="modal-row">
            <label>语录文本</label>
          </div>
          
          <!-- 第二行：语录文本框 -->
          <div class="modal-row">
            <textarea 
              v-model="localCatchPhraseInfo.sign"
              class="quote-textarea"
              placeholder="请输入您的语录..."
              rows="5"
            ></textarea>
          </div>
          
          <!-- 第三行：状态管理 -->
          <div class="modal-row two-columns">
            <div class="column">
              <label>状态管理</label>
            </div>
            <div class="column">
              <select v-model="localCatchPhraseInfo.status" class="status-select">
                <option value="0">正常</option>
                <option value="1">禁用</option>
              </select>
            </div>
          </div>
          
          <!-- 第四行：操作按钮 -->
          <div class="modal-row button-row">
            <button class="btn-clear" @click="closeModal">关闭窗口</button>
            <button class="btn-clear" @click="clearForm">清空数据</button>
            <button class="btn-submit" @click="submitForm">提交数据</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import { saveCatchphrase } from '@/api/catchphrase';
import { Message } from 'element-ui';

export default {
  name: 'CreateCpInfo',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    CatchPhraseInfo: {
       type: Object,
       default: () => ({
        id: null,
        sign: '',
        status: "0"
       })
    }
  },
  data() {
    return {
      localCatchPhraseInfo: {
        ...this.CatchPhraseInfo
      }
    }
  },
  mounted() {
    // this.CatchPhraseInfo = this.props.CatchPhraseInfo
  },
  methods: {
    closeModal() {
      this.clearForm();
      this.isVisible = !this.isVisible;
      this.$emit('update:visible', false);
    },
    clearForm() {
      this.localCatchPhraseInfo = {}
    },
    async saveInfo(){
        const SaveCatchphraseDto = {
            id: this.localCatchPhraseInfo.id,
            sign: this.localCatchPhraseInfo.sign,
            status: this.localCatchPhraseInfo.status
        }
        const resp = await saveCatchphrase(SaveCatchphraseDto);
        if(resp === undefined || resp === null){
          Message.error("数据请求失败！");
          return;
        }
        if(resp.code != 200 && resp.success != true){
          Message.error(resp.msg);
          return;
        }
        Message.success("操作成功！");
        this.closeModal();
    },
    submitForm() {
      this.saveInfo();
      // this.closeModal();
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;
}

@media(max-width: 768px){
.modal-container {
  width: 90% !important;
  padding: 6px !important;
}
}

.modal-container {
  width: 50%;
  height: 60%;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.modal-row {
    display: flex;
    flex-direction: row;
    /* justify-content: center; */
    margin-bottom: 15px;
}

.two-columns {
  display: flex;
  align-items: center;
}

.column {
  flex: 1;
}

.column:first-child {
  margin-right: 10px;
}

.quote-textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: vertical;
  min-height: 100px;
  max-height: 100px;
  font-family: inherit;
}

.status-select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.button-row button {
  margin-left: 10px;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-clear {
  background-color: #f5f5f5;
  color: #333;
}

.btn-clear:hover {
  background-color: #e0e0e0;
}

.btn-submit {
  background-color: #42b983;
  color: white;
}

.btn-submit:hover {
  background-color: #369f6b;
}

/* 过渡动画 */
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  transform: scale(0.9);
}
</style>